import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDStack,
} from '@facet-wealth/design';
import { LoginWithPasskeyButton } from 'Views/Authentication/Components/LoginWithPasskeyButton';
import {
  dataAttrs,
} from 'Helpers/Testing';
import { OtherOptions } from 'Views/Authentication/Components/OtherOptions';
import fr from 'facet-rest';
import {
  AuthenticationLayout,
  AuthenticationLayoutForm,
  AuthenticationSubmitButton, BackToEmailStepButton,
  MFAResetButton,
  OtherMFAButton,
} from '../../Components';

export const AuthMultiFactorTOTPLayout = ({ setAuthCollection }) => {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();

  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'mfa-totp-form'}
        onSubmit={onSubmit}
        errors={unsourcedErrors}
      >
        <FDStack direction={'column'} spacing={2}>
          <BackToEmailStepButton resource={resource} setAuthCollection={setAuthCollection} />
          <MetaControlField attr={'code'} {...dataAttrs('input-mfa-code')} />
          <MetaControlField attr={'rememberDevice'} {...dataAttrs('input-mfa-remember-device')} />
          <AuthenticationSubmitButton />
          <OtherOptions
            resource={resource}
            relationships={[
              fr.relationships.mfaPreferenceSms.name,
              fr.relationships.passkeyLoginChallenge.name,
            ]}
          />
          <OtherMFAButton mfaType={'sms'} setAuthCollection={setAuthCollection} />
          <LoginWithPasskeyButton setAuthCollection={setAuthCollection} />
          <MFAResetButton />
        </FDStack>
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};

AuthMultiFactorTOTPLayout.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};
